/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  GetCampaignInsightsQueryResponse,
  GetCampaignInsightsPathParams,
  GetCampaignInsightsQueryParams,
  GetCampaignInsights404,
} from '../types/GetCampaignInsights'

function getGetCampaignInsightsUrl({
  campaign_id,
}: {
  campaign_id: GetCampaignInsightsPathParams['campaign_id']
}) {
  const res = {
    method: 'GET',
    url: `/api/v1/emailbison/campaigns/${campaign_id}/insights/` as const,
  }
  return res
}

/**
 * @description Return fresh EmailBison stats and chart data for a local campaign.
 * Endpoint:
 * - GET /api/emailbison/campaigns/<campaign_id>/insights/
 * @summary Get campaign insights
 * {@link /api/v1/emailbison/campaigns/:campaign_id/insights/}
 */
export async function getCampaignInsights(
  {
    campaign_id,
  }: { campaign_id: GetCampaignInsightsPathParams['campaign_id'] },
  params?: GetCampaignInsightsQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    GetCampaignInsightsQueryResponse,
    ResponseErrorConfig<GetCampaignInsights404>,
    unknown
  >({
    method: 'GET',
    url: getGetCampaignInsightsUrl({ campaign_id }).url.toString(),
    params,
    ...requestConfig,
  })
  return res.data
}
